import { connect } from "react-redux";
import ViewBusinessItem from "./ViewBusinessItem";
import { bindActionCreators } from "redux";
import { getBusinessItemList, approveItemRequest, updateItemRequest } from "services/redux/businessItems/action";

const mapStateToProps = (state) => ({
  businessItemData: state.businessItemReducer.businessItemList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getBusinessItemList,
      approveItemRequest,
      updateItemRequest,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ViewBusinessItem);
